import React, { useEffect, useState } from "react";
import { CFormGroup, CLabel, CInput, CInvalidFeedback } from "@coreui/react";

import { TextInputPropTypes } from "./TextInput.types";

// default non-empty validator
const defaultValidator = (value) => {
  return !!value && value.length > 0;
};

const TextInput = (props) => {
  const {
    label,
    isRequired,
    id,
    name,
    placeholder,
    initialValue,
    onChange,
    autoComplete,
    validator,
    invalidMessage,
    disabled,
  } = props;
  const [inputValue, setInputValue] = useState("");
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    setInputValue(initialValue || "");
  }, [initialValue]);

  const onChangeHandler = (e) => {
    const value = e.target.value;
    let isDataValid = true;
    if (isRequired) {
      if (validator) {
        isDataValid = validator(value);
      } else {
        isDataValid = defaultValidator(value);
      }
    }
    setIsValid(isDataValid);
    setInputValue(value);
    onChange(name, value, isDataValid);
  };

  return (
    <CFormGroup>
      {label ? (
        <CLabel htmlFor={id}>
          {label} {isRequired ? "*" : ""}
        </CLabel>
      ) : null}
      <CInput
        type="text"
        id={id}
        name={name}
        placeholder={placeholder}
        value={inputValue}
        onChange={onChangeHandler}
        autoComplete={autoComplete}
        invalid={!isValid}
        disabled={disabled}
      />
      {invalidMessage ? (
        <CInvalidFeedback>{invalidMessage}</CInvalidFeedback>
      ) : null}
    </CFormGroup>
  );
};

TextInput.propTypes = TextInputPropTypes;

export default TextInput;
